import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http'
import { registerInstrumentations } from '@opentelemetry/instrumentation'
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web'
import { resourceFromAttributes } from '@opentelemetry/resources'
import { ATTR_SERVICE_NAME } from '@opentelemetry/semantic-conventions'
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base'
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web'
import { ZoneContextManager } from '@opentelemetry/context-zone'
import { escapeRegExp } from '@common/util'
import apiBaseUrl from './io/api/baseUrl'
import { PROD } from './config/stage'

const serviceName = 'entity-console'
const ATTR_SERVICE_STAGE = 'service.stage'

export const initOtel = () => {
  const enabled = import.meta.env.VITE_OTEL_ENABLED !== 'false'
  if (!enabled) {
    return
  }
  const authToken = import.meta.env.VITE_OTEL_AUTH_TOKEN?.trim()
  if (!authToken) {
    return
  }

  const stage = import.meta.env.VITE_STAGE
  const baseEndpoint = stage === PROD ? 'https://otel.platform.eidu.com' : 'https://otel.shared-platform.eidu.com'

  // In local dev the browser can't POST cross-origin to the collector (no CORS for localhost), so export via
  // the Vite dev-server proxy (see vite.config.ts). Built/deployed bundles export directly to the collector.
  const exporterUrl = import.meta.env.DEV ? '/otel-collector/v1/traces' : `${baseEndpoint}/v1/traces`

  const exporter = new OTLPTraceExporter({
    url: exporterUrl,
    headers: {
      Authorization: `Basic ${authToken}`,
    },
  })

  const provider = new WebTracerProvider({
    resource: resourceFromAttributes({
      [ATTR_SERVICE_NAME]: serviceName,
      [ATTR_SERVICE_STAGE]: stage || 'unknown',
    }),
    spanProcessors: [new BatchSpanProcessor(exporter)],
  })
  provider.register({
    contextManager: new ZoneContextManager(),
  })

  const apiOrigin = new URL(apiBaseUrl, window.location.origin).origin
  const apiOriginPattern = new RegExp(`^${escapeRegExp(apiOrigin)}/`)

  registerInstrumentations({
    instrumentations: [
      getWebAutoInstrumentations({
        '@opentelemetry/instrumentation-document-load': {
          enabled: false,
        },
        '@opentelemetry/instrumentation-user-interaction': {
          enabled: false,
        },
        '@opentelemetry/instrumentation-fetch': {
          propagateTraceHeaderCorsUrls: [apiOriginPattern],
          clearTimingResources: true,
          ignoreUrls: [/^https:\/\/otel\./, /\/otel-collector\//],
        },
        '@opentelemetry/instrumentation-xml-http-request': {
          propagateTraceHeaderCorsUrls: [apiOriginPattern],
          ignoreUrls: [/^https:\/\/otel\./, /\/otel-collector\//],
        },
      }),
    ],
  })
}
